export function PlayConditionsIcon() {
  return <v-icon>mdi-motion-play-outline</v-icon>;
}

export function BroadCastIcon() {
  return <v-icon>mdi-access-point</v-icon>;
}

export function GrabHandleNote() {
  return `Your cursor will change into a Grab cursor when hovering over Draggable
      items in CanvasPro.`;
}

{/* Please note this is also imported into OnAir Top Level Component! */}

{/* This should not have a H1 Title! The component that calls this should have that */}
{/* This is not use as a top level component it's self as such it shouldn't have a H1, it should start as with H3s */}

### <v-icon>mdi-plus</v-icon> Add a Queue

Click the large button with a <v-icon>mdi-plus</v-icon> (to the left).

A modal will open where you can you can enter a name and description for the new queue.

### Queue Details

#### <BroadCastIcon /> Broadcast icon

Clicking <BroadCastIcon /> to the top left of the Queue will switch the Channel to that Queue.

Clicking <BroadCastIcon /> on a Scene will switch the Channel to that Scene and Queue, and continue running from there.

#### <v-icon>mdi-cog</v-icon> Queue Config

This will open the Config for that Queue

#### <PlayConditionsIcon /> Play Conditions

Clicking the <PlayConditionsIcon /> to the bottom left of the Queue will open the Play Conditions for the Queue.

Clicking the <PlayConditionsIcon /> in the Scene will open the Play Conditions for the Scene.

#### Moving a Scene

**Note:** <GrabHandleNote />

Hover over the 'Handle' on the left of the Scene. Click, hold, then drag it above or below another Scene, or into another Queue.

#### Moving a Queue

**Note:** <GrabHandleNote />

Hover over the the Top of the Queue, then click, hold and dag it to the Left or Right
of another Queue to move it.

#### Adding a Scene

Click the <v-icon>mdi-plus</v-icon> to the bottom right of the Queue. This will open the Create Scene Dialog.

#### Cloning a Scene or Queue

CTRL + Click, then Drag and Drop on a Scene or Queue in it's new position to Clone it. (Keep CTRL clicked, until you're ready to clone)

{/* Editor Note */}
{/* Can we do more dialogs like this? This enables us to have some text not just an icon on upto 3-4? tabs! */}

{/* Editor Note */}

{/* Create Scene */}

{/* With Template */}
{/* Icon Preview doesn't display */}

{/* Clone Scene */}
{/* No Preview */}
{/* Inconsistent Asset WideCards/Headers */}
{/* Some are extremely Hard to read unless hovering */}
